import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-header-item',
  templateUrl: './nav-header-item.component.html',
  styleUrls: ['./nav-header-item.component.scss'],
})
export class NavHeaderItemComponent {}
